(function () {
  'use strict';
  if (window.PGV146CartModernInstalled) return;
  window.PGV146CartModernInstalled = true;

  var pending = false;
  var cartSnapshot = null;
  var rewardVariants = new Set(['51223262560508', '51223262593276', '51255823335676', '67690283041020']);

  function element(tag, className, label) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (label != null) node.textContent = label;
    return node;
  }
  function rootPath() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return r.endsWith('/') ? r : r + '/';
  }
  function giftMarket() {
    var cfg=window.PG_MARKET_CONFIG||window.PGRewardV101||{};
    var c=String(cfg.country||window.Shopify&&window.Shopify.country||'').toUpperCase();
    return ['GB','UK','US'].includes(c);
  }
  function isUS(){return String((window.PGRewardV101||{}).country||(window.PG_MARKET_CONFIG||{}).country||window.Shopify&&window.Shopify.country||'').toUpperCase()==='US'}
  function marketCurrency(){return isUS()?'USD':'GBP'}
  function firstTier(){return isUS()?9800:7500}
  function extraPrice(kind){return isUS()?({digital:'$15',priority:'$12',express:'$25'})[kind]:({digital:'£9.99',priority:'£7.99',express:'£14.99'})[kind]}
  function variantId(node) {
    return String(node.getAttribute('data-variant-id') || '');
  }
  function lineType(line) {
    var current = line.dataset.pgV146Type;
    if (current === 'reward' || current === 'extra') return current;
    if (line.classList.contains('pg-cart__item--reward') || rewardVariants.has(variantId(line)) || line.querySelector('.mini-cart__reward-included, .pg-cart__reward-included')) return 'reward';
    var title = line.querySelector('.mini-cart__item-title, .pg-cart__item-title');
    if (/first in line|priority \+ express|matching digital|digital download|next.day.preview|express delivery/i.test(String(title && title.textContent || ''))) return 'extra';
    return 'portrait';
  }
  function groupLines(list) {
    if (!list) return;
    var lines = Array.from(list.children).filter(function (n) {
      return n.matches('.mini-cart__item, .pg-cart__item');
    });
    var rank = {portrait: 0, reward: 1, extra: 2};
    var grouped = lines.map(function (node, index) {
      var kind = lineType(node);
      node.dataset.pgV146Type = kind;
      node.removeAttribute('data-pg-v146-first-reward');
      return {node: node, kind: kind, index: index};
    });
    grouped.sort(function (a, b) { return rank[a.kind] - rank[b.kind] || a.index - b.index; });
    if (grouped.some(function (item, index) { return lines[index] !== item.node; })) {
      grouped.forEach(function (item) { list.appendChild(item.node); });
    }
    var first = grouped.find(function (item) { return item.kind === 'reward'; });
    if (first) first.node.setAttribute('data-pg-v146-first-reward', 'true');
  }
  function arrange(host, nodes) {
    if (!host) return;
    var ordered = nodes.filter(function (node) { return node && node.parentNode === host; });
    ordered.forEach(function (node, index) {
      if (host.children[index] !== node) host.insertBefore(node, host.children[index] || null);
    });
  }
  function addonRow(icon, title, detail, type) {
    var row = element('div', 'pg-v146-cart-addons__card');
    row.dataset.pgV146Addon = type;
    row.appendChild(element('span', 'pg-v146-cart-addons__icon', icon));
    var body = element('div', 'pg-v146-cart-addons__copy');
    body.appendChild(element('strong', '', title));
    body.appendChild(element('span', '', detail));
    row.appendChild(body);
    row.appendChild(element('span', 'pg-v146-cart-addons__pill', ''));
    return row;
  }
  function addOns(host) {
    var panel = host.querySelector(':scope > .pg-v146-cart-addons');
    if (panel) return panel;
    panel = element('section', 'pg-v146-cart-addons');
    panel.setAttribute('aria-label', 'Optional extras');
    panel.appendChild(element('h3', 'pg-v146-cart-addons__heading', 'Make it even better'));
    var digital = addonRow('▣', 'Matching digital copy', 'Your selected approved artwork to keep and share.', 'digital');
    var artworkSelect = element('select', 'pg-v146-cart-addons__picker');
    artworkSelect.setAttribute('aria-label', 'Choose existing portrait for matching digital copy');
    artworkSelect.hidden = true;
    digital.querySelector('.pg-v146-cart-addons__copy').appendChild(artworkSelect);
    var digitalButton = element('button', 'pg-v146-cart-addons__action', 'Add '+extraPrice('digital'));
    digitalButton.type = 'button';
    digitalButton.dataset.pgV146DigitalAction = 'true';
    digitalButton.hidden = true;
    digital.appendChild(digitalButton);
    panel.appendChild(digital);
    var priority = addonRow('◷', 'First in Line Artwork', 'Priority artwork preparation, not express delivery.', 'priority');
    var priorityButton = element('button', 'pg-v146-cart-addons__action', 'Add '+extraPrice('priority'));
    priorityButton.type = 'button';
    priorityButton.dataset.pgV146PriorityAction = 'true';
    priorityButton.setAttribute('aria-label', 'Add First in Line Artwork for '+extraPrice('priority'));
    priorityButton.hidden = true;
    priority.appendChild(priorityButton);
    panel.appendChild(priority);
    var express = addonRow('↗', 'Express delivery', extraPrice('express')+' add-on · express courier after artwork approval and printing.', 'express');
    var expressButton = element('button', 'pg-v146-cart-addons__action', 'Add '+extraPrice('express'));
    expressButton.type = 'button';
    expressButton.dataset.pgV146ExpressAction = 'true';
    expressButton.hidden = true;
    express.appendChild(expressButton);
    panel.appendChild(express);
    panel.appendChild(element('p', 'pg-v146-cart-addons__note', 'Digital and First in Line become free with '+(isUS()?'$98':'£75')+' qualifying physical spend.'));
    host.appendChild(panel);
    priorityButton.addEventListener('click', function () { addPriority(priorityButton); });
    digitalButton.addEventListener('click', function () { addPaidExtra(digitalButton, 'digital'); });
    expressButton.addEventListener('click', function () { addPaidExtra(expressButton, 'express'); });
    return panel;
  }
  function status(panel, type, label, included) {
    var pill = panel.querySelector('[data-pg-v146-addon="' + type + '"] .pg-v146-cart-addons__pill');
    if (!pill) return;
    if (pill.textContent !== label) pill.textContent = label;
    pill.classList.toggle('is-included', Boolean(included));
  }
  function updateAddOns(panel, list) {
    if (!panel) return;
    if (!giftMarket()) { panel.hidden = true; return; }
    panel.hidden = false;
    var lines = list ? Array.from(list.querySelectorAll('.mini-cart__item, .pg-cart__item')) : [];
    function anyVariant(ids) {
      return lines.some(function (line) { return ids.includes(variantId(line)); });
    }
    function anyName(regex) {
      return lines.some(function (line) {
        var title = line.querySelector('.mini-cart__item-title, .pg-cart__item-title');
        return regex.test(String(title && title.textContent || ''));
      });
    }
    var cfg = window.PGRewardV101 || {};
    var engine = window.PGRewardEngineV101;
    var matchingCart = cartSnapshot && cartSnapshot.currency === marketCurrency() ? cartSnapshot : null;
    var sourceLines = matchingCart ? matchingCart.items || [] : [];
    // The cart snapshot is the authoritative source; DOM rows can lag behind
    // reward reconciliation or drawer section replacements.
    function hasVariant(id) {
      return matchingCart ? sourceLines.some(function (line) { return Number(line.variant_id) === Number(id); }) : anyVariant([String(id)]);
    }
    var physical = matchingCart && engine && typeof engine.qualifyingSpend === 'function' ? engine.qualifyingSpend(matchingCart) : 0;
    var eligible = matchingCart && engine && typeof engine.eligibleArtworkLines === 'function' ? engine.eligibleArtworkLines(matchingCart) : [];
    var earned = matchingCart && physical >= firstTier() && eligible.length > 0;
    var freeDigital = hasVariant(51223262560508) || earned;
    var freePriority = hasVariant(51223262593276) || earned;
    var paidDigital = hasVariant(67690278158588) || !matchingCart && anyName(/matching digital copy/i) && !freeDigital;
    var paidPriority = hasVariant(49189465850108) || hasVariant(42126320173308) || hasVariant(49189465817340) || !matchingCart && anyName(/first in line artwork/i) && !freePriority;
    var paidExpress = hasVariant(67691583471868) || !matchingCart && anyName(/express delivery only/i);
    var hasProduct = matchingCart ? eligible.length > 0 : lines.some(function (line) { return lineType(line) === 'portrait'; });
    var digitalEnabled = cfg.paidDigitalEnabled === true && physical > 0 && physical < firstTier() && !!eligible.length && !paidDigital && !freeDigital;
    var expressEnabled = cfg.expressOnlyEnabled === true && cfg.expressCheckoutRateExclusive !== true && physical > 0 && !!eligible.length && !paidExpress &&
      !(matchingCart && (matchingCart.items || []).some(function (item) {
        return [42126320173308,49189465817340,44064290636028].includes(Number(item.variant_id)) ||
          /priority\s*\+\s*express|next.day\s+delivery\s+upgrade/i.test(String(item.title || ''));
      }));
    var select = panel.querySelector('.pg-v146-cart-addons__picker');
    if (select) {
      select.hidden = !digitalEnabled;
      if (digitalEnabled) {
        var lastSelection = select.value;
        var options = eligible.map(function (item, index) {
          return {key: String(item.key), label: String(item.product_title || item.title || 'Portrait') + ' · Item ' + (index + 1)};
        });
        var existing = Array.from(select.options).map(function (option) { return option.value; }).join(',');
        if (existing !== options.map(function (option) { return option.key; }).join(',')) {
          select.replaceChildren();
          options.forEach(function (choice) {
            var option = document.createElement('option');
            option.value = choice.key;
            option.textContent = choice.label;
            select.appendChild(option);
          });
          if (options.some(function (choice) { return choice.key === lastSelection; })) select.value = lastSelection;
        }
      }
    }
    var digitalButton = panel.querySelector('[data-pg-v146-digital-action]');
    if (digitalButton) {
      digitalButton.hidden = !digitalEnabled;
      digitalButton.disabled = !digitalEnabled;
    }
    var expressButton = panel.querySelector('[data-pg-v146-express-action]');
    if (expressButton) {
      expressButton.hidden = !expressEnabled;
      expressButton.disabled = !expressEnabled;
    }
    status(panel, 'digital', freeDigital ? 'Included free' : paidDigital ? 'Already added' : cfg.paidDigitalEnabled === true ? extraPrice('digital')+' · choose artwork' : extraPrice('digital')+' · not yet available', freeDigital || paidDigital);
    status(panel, 'priority', freePriority ? 'Included free' : paidPriority ? 'Already added' : extraPrice('priority')+' optional', freePriority || paidPriority);
    status(panel, 'express', paidExpress ? 'Already added' : cfg.expressCheckoutRateExclusive === true ? extraPrice('express')+' · select at checkout' : cfg.expressOnlyEnabled === true ? extraPrice('express') : extraPrice('express')+' · not yet available', paidExpress);
    var btn = panel.querySelector('[data-pg-v146-priority-action]');
    if (btn) {
      btn.hidden = !hasProduct || freePriority || paidPriority;
      btn.disabled = !hasProduct || freePriority || paidPriority;
    }
  }
  async function addPriority(button) {
    if (!button || button.disabled) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      var response = await fetch(rootPath() + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) throw Error('Could not check your basket.');
      var c = await response.json();
      if (c.currency !== marketCurrency() || !giftMarket()) throw Error('This extra is available for UK and US baskets.');
      if ((c.items || []).some(function (line) { return [49189465850108,51223262593276,42126320173308,49189465817340,44064290636028].includes(Number(line.variant_id)); })) throw Error('First in Line is already in your basket.');
      var engine = window.PGRewardEngineV101;
      if (!engine || typeof engine.qualifyingSpend !== 'function') throw Error('Please refresh your basket before adding.');
      var spent = engine.qualifyingSpend(c);
      if (spent >= firstTier()) throw Error('First in Line is already included free at '+(isUS()?'$98':'£75')+'.');
      if (spent <= 0) throw Error('Add a personalised physical portrait first.');
      var result = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: JSON.stringify({items: [{id: 49189465850108, quantity: 1, properties: {'Applies to': 'Artwork in this order'}}]})
      });
      if (!result.ok) throw Error('First in Line could not be added.');
      var verified = await fetch(rootPath() + 'cart.js', {credentials: 'same-origin', cache: 'no-store'}).then(function (r) { if (!r.ok) throw Error('Cart could not be verified.'); return r.json(); });
      if (!(verified.items || []).some(function (line) { return Number(line.variant_id) === 49189465850108; })) throw Error('The addition could not be verified.');
      button.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.jQuery) {
        try { window.jQuery(document).trigger('cart.requestComplete'); } catch (error) {}
      }
      if (window.pgCartSync) Promise.resolve(window.pgCartSync()).catch(function () {});
      schedule();
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try again · '+extraPrice('priority');
      button.setAttribute('title', String(error && error.message || 'Please try again.'));
    }
  }
  async function addPaidExtra(button, service) {
    if (!button || button.disabled || !['digital', 'express'].includes(service)) return;
    var cfg = window.PGRewardV101 || {};
    var enabled = service === 'digital' ? cfg.paidDigitalEnabled === true : (cfg.expressOnlyEnabled === true && cfg.expressCheckoutRateExclusive !== true);
    if (!enabled) return;
    var panel = button.closest('.pg-v146-cart-addons');
    var sourceChoice = panel && panel.querySelector('.pg-v146-cart-addons__picker');
    button.disabled = true;
    button.textContent = 'Adding…';
    button.removeAttribute('title');
    try {
      var engine = window.PGRewardEngineV101;
      if (!engine || typeof engine.qualifyingSpend !== 'function' ||
          typeof engine.eligibleArtworkLines !== 'function') throw Error('Please refresh your basket before adding.');
      var cResponse = await fetch(rootPath() + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!cResponse.ok) throw Error('Could not verify your basket.');
      var cart = await cResponse.json();
      if (!giftMarket() || cart.currency !== marketCurrency()) throw Error('This extra is available for UK and US baskets.');
      var physical = engine.qualifyingSpend(cart);
      var artworks = engine.eligibleArtworkLines(cart);
      if (!artworks.length || physical <= 0) throw Error('Add a personalised physical portrait before choosing this extra.');
      var extras = cart.items || [];
      if (service === 'digital') {
        if (physical >= firstTier()) throw Error('Your matching digital copy is already included free.');
        if (extras.some(function (line) { return [67690278158588,51223262560508].includes(Number(line.variant_id)); }))
          throw Error('A digital copy is already in your basket.');
      } else {
        if (extras.some(function (line) {
          return [67691583471868,42126320173308,49189465817340,44064290636028].includes(Number(line.variant_id)) ||
          /priority\s*\+\s*express|next.day\s+delivery\s+upgrade/i.test(String(line.title || ''));
        })) throw Error('An overlapping express delivery upgrade is already in your basket.');
      }
      var id, properties;
      if (service === 'digital') {
        if (!sourceChoice || !sourceChoice.value) throw Error('Choose the portrait for the matching digital copy.');
        if (typeof engine.preparePaidExtraSource !== 'function') throw Error('Artwork linking is not ready. Please refresh.');
        var prepared = await engine.preparePaidExtraSource(sourceChoice.value);
        cart = prepared.cart;
        var src = prepared.source;
        var group = src && src.properties && src.properties._pg_artwork_group;
        if (!src || !group) throw Error('The matching artwork could not be linked.');
        if (engine.qualifyingSpend(cart) >= firstTier()) throw Error('Your digital copy is now included free.');
        id = 67690278158588;
        properties = {
          _pg_paid_extra_v146: 'matching_digital',
          _pg_same_artwork: 'true',
          _pg_source_key: String(src.key || ''),
          _pg_source_product: String(src.product_id || ''),
          _pg_source_variant: String(src.variant_id || ''),
          _pg_source_title: String(src.product_title || src.title || ''),
          _pg_artwork_group: String(group),
          'Digital artwork': 'Same approved portrait artwork'
        };
      } else {
        id = 67691583471868;
        properties = {
          _pg_paid_extra_v146: 'express_delivery_only',
          _pg_service_scope: 'one_per_order',
          _pg_delivery_timing: 'after_artwork_approval_and_print',
          'Delivery upgrade': 'Express shipping after artwork approval',
          'Applies to': 'Personalised products in this order'
        };
      }
      var result = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: JSON.stringify({items: [{id: id, quantity: 1, properties: properties}]})
      });
      if (!result.ok) throw Error('The extra is not available for purchase yet.');
      var confirmation = await fetch(rootPath() + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (!confirmation.ok) throw Error('The extra was added but could not be verified.');
      var confirmed = await confirmation.json();
      var match = (confirmed.items || []).filter(function (item) { return Number(item.variant_id) === id; });
      if (match.length !== 1 || Number(match[0].quantity) !== 1 ||
          String(match[0].properties && match[0].properties._pg_paid_extra_v146 || '') !==
          (service === 'digital' ? 'matching_digital' : 'express_delivery_only')) {
        throw Error('Please refresh your basket to verify this extra before checkout.');
      }
      cartSnapshot = confirmed;
      button.textContent = 'Added';
      if (window.pgCartSync) await window.pgCartSync();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.jQuery) {
        try { window.jQuery(document).trigger('cart.requestComplete'); } catch (error) {}
      }
      schedule();
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try again · '+extraPrice(service);
      button.setAttribute('title', String(error && error.message || 'Please try again.'));
      var message = panel && panel.querySelector('.pg-v146-cart-addons__error');
      if (!message && panel) {
        message = element('p', 'pg-v146-cart-addons__error');
        message.setAttribute('role', 'status');
        panel.appendChild(message);
      }
      if (message) message.textContent = String(error && error.message || 'The extra could not be added.');
    }
  }
  function enhanceDrawer(drawer) {
    var form = drawer.querySelector('form[data-cart-form="mini-cart"]');
    if (!form) return;
    drawer.classList.add('pg-v146-drawer');
    var heading = drawer.querySelector(':scope > .pg-v146-cart-head');
    if (!heading) {
      heading = element('div', 'pg-v146-cart-head');
      heading.appendChild(element('span', 'pg-v146-cart-head__title', 'Your basket'));
      heading.appendChild(element('span', 'pg-v146-cart-head__count'));
      drawer.insertBefore(heading, form);
    }
    var footer = Array.from(form.children).find(function (n) { return n.tagName === 'UL' && !n.classList.contains('cart_items'); });
    if (!footer) return;
    footer.classList.add('pg-v146-cart-footer');
    var scroll = form.querySelector(':scope > .pg-v146-cart-scroll');
    if (!scroll) {
      scroll = element('div', 'pg-v146-cart-scroll');
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-label', 'Your products, gifts and extras');
      form.insertBefore(scroll, footer);
    }
    Array.from(form.children).forEach(function (n) {
      if (n === scroll || n === footer || n.matches('input[type="hidden"]')) return;
      if (n.matches('.pg-reward-rail, .pg-reward-rail-v101, .cart_items, .cart_content__continue-shopping, .pg-uk-artwork-choice-v146, .pg-uk-a5-v146, [data-pg-complete-set-mount="drawer"]')) scroll.appendChild(n);
    });
    var list = scroll.querySelector(':scope > .cart_items');
    groupLines(list);
    var panels = addOns(scroll);
    var rail = scroll.querySelector(':scope > .pg-reward-rail, :scope > .pg-reward-rail-v101');
    var art = scroll.querySelector(':scope > .pg-uk-artwork-choice-v146');
    var a5 = scroll.querySelector(':scope > .pg-uk-a5-v146');
    var upsell = scroll.querySelector(':scope > [data-pg-complete-set-mount="drawer"]');
    var cont = scroll.querySelector(':scope > .cart_content__continue-shopping');
    arrange(scroll, [rail, list, art, a5, panels, upsell, cont]);
    var count = heading.querySelector('.pg-v146-cart-head__count');
    if (count && list) {
      count.textContent = String(Array.from(list.querySelectorAll('.mini-cart__item')).filter(function (line) { return lineType(line) === 'portrait'; }).length);
    }
    updateAddOns(panels, list);
  }
  function enhanceMain() {
    var cart = document.querySelector('#pg-cart');
    if (!cart) return;
    cart.classList.add('pg-v146-main-cart');
    var column = cart.querySelector('.pg-cart__items-col');
    if (!column) return;
    var products = column.querySelector(':scope > .pg-cart__card--items');
    groupLines(products);
    var rail = column.querySelector(':scope > .pg-reward-rail, :scope > .pg-reward-rail-v101');
    var art = column.querySelector(':scope > .pg-uk-artwork-choice-v146');
    var a5 = column.querySelector(':scope > .pg-uk-a5-v146');
    var upsell = column.querySelector(':scope > [data-pg-complete-set-mount="cart"]');
    var trust = column.querySelector(':scope > .pg-cart__trust-trio');
    var panels = addOns(column);
    arrange(column, [rail, products, art, a5, panels, upsell, trust]);
    updateAddOns(panels, products);
  }
  function apply() {
    pending = false;
    document.querySelectorAll('.cart_content').forEach(enhanceDrawer);
    enhanceMain();
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(apply);
  }
  function boot() {
    apply();
    document.addEventListener('pg:cart-synchronised', function (event) { if (event.detail && event.detail.cart) cartSnapshot = event.detail.cart; schedule(); });
    ['pg:cart-form-patched', 'cart:refresh', 'shopify:cart:lines-update', 'shopify:section:load'].forEach(function (name) {
      document.addEventListener(name, schedule);
    });
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest('.mini_cart, .pg-drawer-close, .cart_content')) setTimeout(schedule, 80);
    }, true);
    if (window.jQuery) window.jQuery(document).on('cart.requestComplete', function () { setTimeout(schedule, 80); });
    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (m) {
          return Array.from(m.addedNodes || []).some(function (node) {
            if (node.nodeType !== 1) return false;
            var selectors = '.cart_content, .cart_items, .mini-cart__item, .pg-cart__item, .pg-reward-rail, .pg-uk-artwork-choice-v146, .pg-uk-a5-v146, [data-pg-complete-set-mount]';
            return node.matches && node.matches(selectors) || node.querySelector && node.querySelector('.cart_content, .mini-cart__item, .pg-uk-a5-v146, [data-pg-complete-set-mount]');
          });
        });
        if (relevant) schedule();
      });
      observer.observe(document.body, {childList: true, subtree: true});
    }
    [200, 800, 1800].forEach(function (ms) { setTimeout(schedule, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
})();